import { LegalPage } from './legal/LegalPage';
import { doc } from './legal/content/user-agreement';

export const User = () => <LegalPage doc={doc} />;
